// extracted by mini-css-extract-plugin
module.exports = {"name__link":"formatters_name__link__pZZCR","name__link__name":"formatters_name__link__name__2ZeF4"};